import Customization from "./customization";
import { StoreCategory, css } from "./customization/category";
import BaseCustomization from "./customization/base";
import CustomizationRequest from "./customization/request";

// Connects to data-controller="site-builder--fonts"
export default class extends BaseCustomization {
  static targets = ["selection", "reset"];
  static values = { pairing: Number };

  initialize() {
    this.tabItem = document.getElementById("for-fonts");
    this.appliedById = false;
  }

  initializeSelection() {
    const defaultValue = this.values();
    this.removeSelectedOption();

    if (defaultValue["body-font"] || defaultValue["heading-font"]) {
      this.#selectByValue(defaultValue);
      this.highlightTabSelection();
      this.appliedById = false;
    } else if (defaultValue) {
      this.#selectById(defaultValue);
      this.highlightTabSelection();
      this.appliedById = true;
    }
  }

  applyWithNames(e) {
    const { headingFontName, bodyFontName } = e.currentTarget.dataset;

    const payload = {
      "heading-font": headingFontName,
      "body-font": bodyFontName,
    };
    e.currentTarget.classList.add("selected");
    Customization.localUpdate(payload, StoreCategory.CSS);
    this.highlightTabSelection();
    this.appliedById = false;
    this.removeSelectedOption();
    this.showReset();
  }

  applyWithId(e) {
    const { fontPairingId } = e.currentTarget.dataset;
    const payload = {
      "font-pairing-id": fontPairingId,
    };
    Customization.serverUpdate(payload);
    this.appliedById = true;
    this.removeSelectedOption();
    this.showReset();
  }

  reset() {
    this.removeSelectedOption();
    if (this.appliedById) {
      Customization.serverUpdate({ "font-pairing-id": undefined });
    } else {
      const resetPayload = { "heading-font": null, "body-font": null };
      Customization.localUpdate(resetPayload, StoreCategory.CSS);
    }
    this.removeTabSelection();
    this.hideReset();
  }

  #selectByValue(payload) {
    const current = this.selectionTargets.find((selection) => {
      const { headingFontName, bodyFontName } = selection.dataset;
      return (
        headingFontName === payload["heading-font"] &&
        bodyFontName === payload["body-font"]
      );
    });

    if (current) {
      current.classList.add("selected");
    }
  }

  #selectById(id) {
    const current = this.selectionTargets.find((selection) => {
      const { fontPairingId } = selection.dataset;
      return fontPairingId === id;
    });

    if (current) {
      current.classList.add("selected");
    }
  }

  fetchFromStore() {
    return css.fonts || {};
  }

  fetchFromPreview() {
    return CustomizationRequest.getFontPairing() || {};
  }
}
